/** Flatten target_plans API rows (one row per plan duration window). */
export function flattenTargetPlanSummaries(targetPlans = []) {
  const flat = [];
  for (const plan of targetPlans) {
    const durations = plan.durations || [];
    if (durations.length === 0) {
      flat.push({
        id: plan.id,
        title: plan.title,
        description: plan.description,
        template_id: plan.template_id,
        assigned_to_id: plan.assigned_to_id,
        assigned_by_id: plan.assigned_by_id,
        priority_order: plan.priority_order,
        created_at: plan.created_at,
        duration_id: null,
        start_date: null,
        end_date: null,
      });
      continue;
    }
    for (const d of durations) {
      flat.push({
        id: plan.id,
        title: plan.title,
        description: plan.description,
        template_id: plan.template_id,
        assigned_to_id: plan.assigned_to_id,
        assigned_by_id: plan.assigned_by_id,
        priority_order: plan.priority_order,
        created_at: plan.created_at,
        duration_id: d.id,
        start_date: d.start_date || d.active_from || null,
        end_date: d.end_date || d.active_to || null,
      });
    }
  }
  return flat;
}
